import styles from "./styles.module.scss";
import Link from "next/link";
import Image from "next/image";
import Logo from "../../../public/static-next/logo-finanzero.svg";

interface Type {
  type: string | boolean;
}

export const BannerFNZ = ({ type }: Type) => {
  return type == "banner" ? (
    <div className={[styles.BannerFNZ, styles.templateLpBackground].join(" ")}>
      <div className={styles.column}>
        <div className={styles.align}>
          <h2>
            Simule seu empréstimo on-line
            <span>Rápido e seguro</span>
          </h2>

          <Link
            href={
              "https://finanzero.com.br/simule-seu-emprestimo/?utm_source=konkero&utm_medium=affiliate&utm_campaign=botao"
            }
            passHref
            className={styles.ctaBtn}
          >
            Saiba mais
          </Link>
        </div>
      </div>
      <div className={styles.column}>
        <div className={styles.imageWrapper}>
          <Image
            width={192}
            height={336}
            alt="Simule emprestimo Finanzero"
            src="/static-next/imagem_banner.png"
          />
        </div>
      </div>
    </div>
  ) : (
    <div className={styles.cta} style={{ padding: 16 }}>
      <div className={styles.column}>
        <div className={styles.align}>
          <Logo title={"Logo FinanZero"} />
          <Link
            href={
              "https://finanzero.com.br/simule-seu-emprestimo/?utm_source=konkero&utm_medium=affiliate&utm_campaign=botao"
            }
            passHref
            className={styles.ctaBtn}
          >
            Saiba mais
          </Link>
        </div>
      </div>
    </div>
  );
};
